import React, { Component } from 'react';
import * as $ from 'jquery';
import Invoice from './Invoice.js';
import InvoiceSearch from './InvoiceSearch.js';
import Invoices from './Invoices.js';
import axios from 'axios';
import moment from 'moment-timezone';
import { MENU } from '../Sidebar.js';
import { translate } from 'react-i18next';

export const STATUS = {
  PENDING: 1,
  PAID: 2,
  PROCESS: 3
};

let cancelToken;
let state;
let tokenSession;

class InvoicesContainer extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    if (this.state.invoices.length == 0) {
      this.getPendingInvoices({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      });
    }
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  didGetInvoices = (response) => {
    const { t } = this.props;

    const callback = () => {
      if (this.state.invoices.length > 0) {
        $('html, body').animate({
          scrollTop: $('#invoices').offset().top - $('.navbar').height() - 20
        }, 800);
        this.getInvoice(this.state.invoice.id);
      } else {
        this.setState({ error: t('dashboard.invoices.no_results') });
      }
    };

    this.setState({
      invoice: response[0],
      invoices: response,
      isSearching: false,
      pdf: "",
      xml: ""
    }, callback);
  }

  didGetPendingInvoices = (response) => {
    const { t } = this.props;
    const permissionStatus = this.props.getPermissionStatus(MENU.INVOICES);

    const callback = () => {
      if (!permissionStatus && this.state.invoices.length > 0) {
        $('html, body').animate({
          scrollTop: $('#invoices').offset().top - $('.navbar').height() - 20
        }, 800);
        this.getInvoice(this.state.invoice.id);
      } else {
        this.setState({ error: t('dashboard.invoices.no_pending_found') });
      }
    };

    let balance_mxn = 0;
    let balance_mxn_solucion = 0;
    response.map((invoice) => {
        balance_mxn_solucion = balance_mxn + invoice.balance_mxn
        if (balance_mxn_solucion <= 190000 && invoice.status == 1) {
          invoice.checked = true;
          balance_mxn += invoice.balance_mxn
          this.state.get_data_invoices.push(invoice)
          this.state.get_data_invoives_page.push(invoice)
          this.setState({
            pay_invoice: true,
            total_invoices:balance_mxn,
          });
        }
      
    })


    this.setState({
      invoice: response[0],
      invoices: response,
      isSearching: false,
      total_invoices: balance_mxn,
      pdf: "",
      xml: ""
    }, callback);
  }

  didGetPdf = (response) => {
    this.setState({ pdf: response });
  }

  didGetXml = (response) => {
    this.setState({ xml: response });
  }

  getInitState = () => {
    return ({
      endDate: "",
      error: "",
      invoice: null,
      invoices: [],
      isSearching: false,
      pdf: "",
      remission: "",
      startDate: "",
      xml: "",
      get_data_invoices: [],
      total_invoices: 0,
      total_abono: 0,
      pay_invoice: false,
      can_pay_invoice: true,
      get_data_invoives_pending: [],
      get_data_invoives_page: []
    })
  }

  getInvoice = (invoiceId) => {
    this.getPdf({
      factura_id: invoiceId,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.getXml({
      factura_id: invoiceId,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  getInvoices = (params) => {
    this.props.post(
      "/getInvoices",
      params,
      (response) => this.didGetInvoices(response),
      (error) => {
        this.setState({ isSearching: false });
        this.props.handleErrorResponse(error);
      },
      cancelToken,
      () => this.setState({ isSearching: false })
    );
  }

  getPendingInvoices = (params) => {
    this.props.post(
      "/getPendingInvoices",
      params,
      (response) => this.didGetPendingInvoices(response),
      (error) => {
        this.setState({ isSearching: false });
        this.props.handleErrorResponse(error);
      },
      cancelToken,
      () => this.setState({ isSearching: false })
    );
  }

  getPdf = (params) => {
    this.props.post(
      "/facturas/pdf",
      params,
      (response) => this.didGetPdf(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getXml = (params) => {
    this.props.post(
      "/facturas/xml",
      params,
      (response) => this.didGetXml(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleClearError = () => {
    this.setState({ error: "" });
  }

  handleEndDate = (endDate) => {
    this.setState({ endDate: endDate });
  }

  handleInvoiceClick = (invoice) => {
    try {
      let balance_mxn = this.state.total_invoices;
      const get_data_invoives_page = this.state.get_data_invoives_page.indexOf(invoice)
      const get_data_invoices = this.state.get_data_invoices.indexOf(invoice)
      if (get_data_invoives_page > -1 || get_data_invoices > -1) {
        if (this.state.get_data_invoives_page.length > 1) {
          this.state.get_data_invoives_page.splice(get_data_invoives_page, 1)
          this.state.get_data_invoices.splice(get_data_invoices, 1)
          balance_mxn -= invoice.balance_mxn
          invoice.checked = false;
          this.setState({
            can_pay_invoice: true
          });
        } else {
          this.setState({
            can_pay_invoice: false
          });
          this.state.get_data_invoives_page.splice(get_data_invoives_page, 1)
          this.state.get_data_invoices.splice(get_data_invoices, 1)
          balance_mxn -= invoice.balance_mxn
          invoice.checked = false;
        }
      } else {
        //console.log(balance_mxn);
        const balance_mxn_solucion = this.state.total_invoices + invoice.balance_mxn
        this.setState({
          can_pay_invoice: true
        });
        if (balance_mxn_solucion <= 190000) {
          this.state.get_data_invoives_page.push(invoice)
          balance_mxn += invoice.balance_mxn
          invoice.checked = true;
        } else {
          this.state.get_data_invoives_page.push(invoice)
          balance_mxn += invoice.balance_mxn
          invoice.checked = true;
        }
      }
      this.setState({
        total_invoices: balance_mxn
      })
    } catch (error) {
      console.error(error);
    }  
  }


  handleInvoiceViewClick = (invoice) => {
    console.log(invoice)
    this.setState({
      invoice: invoice,
      pdf: "",
      xml: ""
    }, () => this.getInvoice(invoice.id));
  }

  handleInvoiceSearch = (event) => {
    event.preventDefault();

    this.setState({
      error: "",
      isSearching: true
    });

    this.getInvoices({
      remission: this.state.remission,
      end_date: moment(this.state.endDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      start_date: moment(this.state.startDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  handleRemissionChange = (event) => {
    this.setState({ remission: event.target.value });
  }

  handleStartDate = (startDate) => {
    this.setState({ startDate: startDate });
  }

  renderInvoice = () => {
    return (
      <Invoice
        key={this.state.invoice.id}
        pdf={this.state.pdf}
        xml={this.state.xml} />
    );
  }

  renderInvoiceSearch = () => {
    return (
      <InvoiceSearch
        endDate={this.state.endDate}
        error={this.state.error}
        handleClearError={this.handleClearError}
        handleEndDate={this.handleEndDate}
        handleInvoiceSearch={this.handleInvoiceSearch}
        handleRemissionChange={this.handleRemissionChange}
        handleStartDate={this.handleStartDate}
        isSearching={this.state.isSearching}
        remission={this.state.remission}
        startDate={this.state.startDate} />
    );
  }

  renderInvoices = () => {
    return (
      <Invoices
        handleInvoiceViewClick={this.handleInvoiceViewClick}
        handleInvoiceClick={this.handleInvoiceClick}
        invoice={this.state.invoice}
        invoices={this.state.invoices}
        get_data_invoices={this.state.get_data_invoices}
        get_data_invoives_page={this.state.get_data_invoives_page}
        total_invoices={this.state.total_invoices}
        pay_invoice={this.state.pay_invoice}
        can_pay_invoice={this.state.can_pay_invoice}
        isExternal={false} />
    );
  }

  render() {
    const { t } = this.props;
    const permissionStatus = this.props.getPermissionStatus(MENU.INVOICES);
    return (
      <div className="invoice_internal">
        <h2 className="page-header">{t('dashboard.invoices.heading')}</h2>
        {permissionStatus && <div className="jumbotron alert-warning">{permissionStatus}</div>}
        {!permissionStatus &&
          <div>
            {this.renderInvoiceSearch()}
            {this.state.invoices.length > 0 && this.renderInvoices()}
          </div>
        }
        <div className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button id="modal_colosepayment" type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;
                  </span>
                </button>
              </div>
              {this.state.invoice && this.renderInvoice()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(InvoicesContainer);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/InvoicesContainer.js